import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import i18n from "@/i18n";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: `/${i18n.locale}`
        },
        {
            path: '/:lang',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '/facebook',
                    beforeEnter() {
                        location.href = 'https://www.facebook.com/parencik/'
                    }
                },
                {
                    path: '/twitter',
                    beforeEnter() {
                        location.href = 'https://twitter.com/parencik'
                    }
                },
                {
                    path: '/snapchat',
                    beforeEnter() {
                        location.href = 'https://www.snapchat.com/add/parencik'
                    }
                },
                {
                    path: '/github',
                    beforeEnter() {
                        location.href = 'https://www.github.com/parencik'
                    }
                },
                {
                    path: '/linkedin',
                    beforeEnter() {
                        location.href = 'https://www.linkedin.com/in/piotr-arent-416545b2/'
                    }
                },
                {
                    path: '/instagram',
                    beforeEnter() {
                        location.href = 'https://www.instagram.com/parencik/'
                    }
                },
                {
                    path: '/messenger',
                    beforeEnter() {
                        location.href = 'https://www.messenger.com/t/parencik'
                    }
                },
                {
                    path: "/",
                    name: "home",
                    component: Home
                },
                {
                    path: "about",
                    name: "about",
                    component: Home
                },
                {
                    path: "contact",
                    name: "contact",
                    component: Home
                },
                {
                    path: "*",
                    name: "everything else",
                    redirect: "/"
                }]
        }
    ]
});
